<template>
  <el-dialog :title="question.id ? `编辑题目` : `${question.curriculumChapterName || ''}添加题目`" :visible.sync="dialogVisible" custom-class="custom" :close-on-click-modal="false" :append-to-body="true">
    <question-edit ref="questionEdit" @callback="questionCallback" :update="dialogVisible" :type="type" :data="question" :showMatrix="showMatrix"></question-edit>
    <div slot="footer" class="dialog-footer" @click="$refs.questionEdit.setUeEditorShow(false)">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirm" v-loading="loading" :disabled="loading">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {
  },
  props: {
    value: "",
    data: {
      type: Object,
      default: () => { return {} },
    },
    type: "",
    isSubmit: {
      type: Boolean,
      default: true,
    },
    showMatrix: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      question: {},
      dialogVisible: false,
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = this.value;
    },
    dialogVisible(val) {
      if (val) {
        this.question = this.func.depCopy(this.data);
      } else {
        this.$emit('callback', 'hide');
      }
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    questionCallback(data) {
      if (typeof data == "string") {
        this.$emit("callback", data, this.question);
      } else {
        this.question = data;
      }
    },
    confirm() {
      if (!this.$refs.questionEdit.questionCheck(this.question)) {
        return;
      }
      this.loading = true;
      setTimeout(() => {
        // if (!this.question.subjectCatalogueId && !this.question.id) {
        //   this.func.message("error", "请选择专业课程");
        //   this.loading = false;
        //   return;
        // }
        let params = this.func.depCopy(this.question);
        delete params.knowledgePoints;
        delete params.testPaperViewModels;
        if (this.isSubmit) {
          this.https("post", "/api/Question/AddOrEditQuestion", params).then(res => {
            this.loading = false;
            if (res.success) {
              this.$emit('callback', 'success', res.response);
            } else {
              this.func.message("error", res.msg);
            }
          }).catch(() => {
            this.loading = false;
          })
        } else {
          this.$emit("callback", "confirm", params);
          this.loading = false;
        }
      }, 200);
    }
  },
}
</script>
<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/QuestionEditModel.vue